import { PATH_DASHBOARD, PATH_INVOICES_OVERVIEW } from '~/router';

const defaultConfig = {
  account: {
    visible: true,
  },
  backButton: {
    path: PATH_DASHBOARD,
  },
  contacts: {
    visible: true,
  },
  dashboard: {
    visible: true,
  },
  expenses: {
    visible: true,
  },
  exports: {
    visible: true,
  },
  invoices: {
    visible: true,
  },
};

export const navbarConfig = {
  default: {
    ...defaultConfig,
  },
  usa: {
    ...defaultConfig,
    backButton: {
      path: PATH_INVOICES_OVERVIEW,
    },
    dashboard: {
      visible: false,
    },
    expenses: {
      visible: false,
    },
  },
};
